import JsCryptoWrapper from './JsCryptoWrapper';
import ArrayHelper from '../helpers/ArrayHelper';

//import type from 'type-detect';

class JsCryptoAesCbc {
	static isSupported() {
		return true;
	}

	/**
	 * Initialises the WebCrypto sub-system. Only one instance is needed.
	 */
	constructor() {
		this.wrapper = new JsCryptoWrapper();
	}

	/**
	 * returns an AES-CBC cryptoKey from Uint8Array(16) for use with decrypt
	 */
	createKey( key ) {
		try {
			if( key.length !== 16 ) {
				throw new Error( 'JsCryptoAesCbc.createKey length must be 16');
			}

			return this.wrapper.importKey(
				'raw',
				key,
				{ name: 'AES-CBC' },
				false,
				['encrypt', 'decrypt']
			);
		}
		catch(err) {
			return Promise.reject(err);
		}
	}

	_decryptInternal( cryptoKey, iv, cypherText) {
		return this.wrapper.decrypt(
			{
				name: 'AES-CBC',
				iv,
			},
			cryptoKey,
			cypherText );
	}

	_stripPadding( clearText ) {
		let myClearText = clearText;
		let len = myClearText.length;

		// now we need to check for padding, and if its there, strip it.
		let p = myClearText[len - 1];

		if( p > 0 && p <= 16 ) {
			let good = true;
			for( let i = len - p; i < len; i++ ) {
				if( myClearText[i] !== p ) {
					good = false;
					break;
				}
			}

			if( good ) {
				myClearText = myClearText.subarray(0, len - p);
			}
		}

		return myClearText;
	}

	decrypt( cryptoKey, iv, cypherText ) {
		try{
			// we need to use a Uint8Array for some of our processing
			let myCypherText = ArrayHelper.makeUint8Array(cypherText);

			// if we're non-modulo 16 truncate if necessary
			let truncated;
			({ data: myCypherText, truncated } = ArrayHelper.makeModulo16(myCypherText));

			return this._decryptInternal( cryptoKey, iv, myCypherText )
			.then( decrypted => {
				let result = new Uint8Array(decrypted );

				if( !truncated ) {
					result = this._stripPadding(result);
				}

				return result;
			});
		}
		catch(err) {
			return Promise.reject(err);
		}
	}
}

export default JsCryptoAesCbc;



// WEBPACK FOOTER //
// ./src/aes/JsCryptoAesCbc.js